import { getAxiosData } from '@internal/utils/api/axios'
import { TLocale } from '@internal/utils/machine/i18n/TLocale'
import { Machine, machineDTOtoMachine } from '@internal/utils/machine/Machine'
import { MachineType } from '@internal/utils/machine/MachineType'
import axios from 'axios'
import { environment } from 'environment/environment'
import {
  GetSuggestRequestParams,
  GetSuggestResponse,
  GetSuggestResponseDto,
} from './types/suggestTypes'

const machineSearchClient = axios.create({
  baseURL: `${environment.MACHINE_SEARCH_URL}/api`,
  timeout: 30000,
})

export type ModelSearchResult = {
  BRAND: string
  BASE_MODEL: string
  MODEL: string
  MODEL_EXTENSION?: string
  MODEL_SERIES?: string
  MACHINE_TYPE?: MachineType
}

export const searchBrands = (query: string, abortSignal?: AbortSignal) =>
  machineSearchClient
    .get<string[]>(`/v1/brands/search`, {
      signal: abortSignal,
      params: {
        query,
        limit: 20,
      },
    })
    .then((res) => res.data)
    .then((brands) => brands as string[])
    .catch((e) => [])

export const searchModels = ({
  query,
  brand,
  abortSignal,
  machineType,
}: {
  query: string
  brand?: string
  abortSignal?: AbortSignal
  machineType?: MachineType
}): Promise<ModelSearchResult[]> =>
  machineSearchClient
    .get<ModelSearchResult[]>(`/v1/models/autocomplete`, {
      signal: abortSignal,
      params: {
        query,
        BRAND: brand,
        limit: 20,
        MACHINE_TYPE: machineType,
      },
    })
    .then(getAxiosData)
    .catch((e) => [])

export const suggest = ({
  query,
  abortSignal,
  BRAND,
  MACHINE_TYPE,
  locale,
  countryCode,
}: {
  query: string
  abortSignal?: AbortSignal
  BRAND?: string
  MACHINE_TYPE?: string
  locale: TLocale
  countryCode: string
}): Promise<GetSuggestResponse> =>
  machineSearchClient
    .get<GetSuggestResponseDto>(`/v1/search/suggest`, {
      signal: abortSignal,
      params: {
        query,
        BRAND,
        MACHINE_TYPE,
        locale,
        country: countryCode,
        'model-search-field': ['RAW_MODEL'],
      } satisfies GetSuggestRequestParams,
    })
    .then(getAxiosData)
    .then(({ idMatch: idMatchDto, ...response }): GetSuggestResponse => {
      // we will only return one available machines that can be found via search in that country
      const idMatch = idMatchDto.reduce<Machine | null>(
        (idMatch, { machine: dto }) => {
          if (idMatch) {
            return idMatch
          }

          const machine = machineDTOtoMachine(dto)
          return machine.available ? machine : null

          // rules logic needs to be used when we get back the full machine data
          // if (!machine.available || !machine.pdp) {
          //   return null
          // }
          // if (typeof machine.serp.countries[countryCode] === 'boolean') {
          //   return machine.serp.countries[countryCode] ? machine : null
          // }
          // return machine.serp.other ? machine : null
        },
        null
      )

      if (idMatch) {
        return {
          ...response,
          idMatch: idMatch,
        }
      }

      return response
    })
